// extracted by mini-css-extract-plugin
export var addressCarousel = "carousel-module--address-carousel--e2951";
export var addressCarouselItem = "carousel-module--address-carousel-item--139af";
export var addressImg = "carousel-module--address-img--04ad3";
export var addressImgSolo = "carousel-module--address-img-solo--8eee6";
export var carouselLightBoxOpener = "carousel-module--carousel-light-box-opener--76374";